import React from "react";

import {Route, Switch} from "react-router-dom";

// General:
import Login from "../auth/Login/Login";
import {Alert, ReduxProtectedRoute} from "@leap4/frontend";
import {requiredAuthRoles, BACKEND_SERVICE_NAME} from "../../config/generals";
import {urlService} from "./urlsService";


//  Modules:
import AddEditDataPoint from "../modules/dataPoints/AddEditDataPoint/AddEditDataPoint";
import AddEditAdServer from "../modules/adServers/AddEditAdServer/AddEditAdServer";
import AddEditPartner from "../modules/partners/AddEditPartner/AddEditPartner";
import PublisherTagsModule from "../modules/publisherTags";
import DataPointsModule from "../modules/dataPoints";
import PartnersModule from "../modules/partners";
import AdServersModule from "../modules/adServers";
import PublisherDataPoints from "../modules/publisherDataPoints/index";
import AdServerTagsModule from "../modules/adServerTags";
import AlertsModule from "../modules/alerts/AlertsModule";
import {AddAlert} from "../modules/alerts/Alert/create/AddAlert";
import {EditAlert} from "../modules/alerts/Alert/edit/EditAlert";
import {EditGroup} from "../modules/groups/Group/edit/EditGroup"
import DataPointOverview from "../modules/dataPointOverview/dataPointOverview";
import HomePage from "../modules/home/home";
import AdserverOverview from "../modules/adServers/Overview/AdserverOverview.container";
import GroupsModule from "../modules/groups/GroupsModule";
import {AddGroup} from "../modules/groups/Group/create/AddGroup";
import {AliasSupplyPartners} from "../modules/partners/networkPartners/aliasSupplyTable";
import {AliasDemandPartners} from "../modules/partners/networkPartners/aliasDemandTable";
import PartnerOverview from "../modules/partners/PartnerOverview";
import {PartnersSupplyTable} from "../modules/partners/PartnersSupplyTable";
import {PartnersDemandTable} from "../modules/partners/PartnersDemandTable";
import {AssignSupplyToPartnerTable} from "../modules/partners/networkPartners/assignSupplyToPartnerTable";
import {AssignDemandToPartnerTable} from "../modules/partners/networkPartners/assignDemandToPartnerTable";
import { PriceRulesDashboard } from "../modules/priceRules/PriceRules";
import {AddEditPriceRule} from "../modules/priceRules/AddEditPriceRule/AddEditPriceRule";
import {AddEditAlias} from "../modules/partners/networkPartners/AddEditAlias/AddEditAlias";
import {OverviewSupplyTable} from "../modules/partners/networkPartners/overviewSupplyTable";
import {OverviewDemandTable} from "../modules/partners/networkPartners/overviewDemandTable";
import ReportsModule from "../modules/reports";

const Routes = () => {

    return (
        <section className="container">
            <Alert/>
            <Switch>
                <Route exact path="/login" component={Login}/>

                {/************** Home *************/}
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={HomePage} path={urlService.app()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={HomePage} path={urlService.home()}/>

                {/*    /!* Redirect to main. *!/*/}
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={DataPointsModule} path={urlService.dataPoints()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AddEditDataPoint} path={urlService.createDataPoint()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AddEditDataPoint} path={urlService.editDataPoint()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={DataPointOverview} path={urlService.dataPointOverview()}/>

                {/************** Ad-Servers *************/}
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AdServersModule} path={urlService.adServers()}/>
                <ReduxProtectedRoute backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AdserverOverview} path={urlService.adServerOverview()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AddEditAdServer} path={urlService.createAdServer()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AddEditAdServer} path={urlService.editAdServer()}/>



                {/************** PARTNERS *************/}
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={PartnersModule} path={urlService.partners()}/>
                <ReduxProtectedRoute backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={PartnerOverview} path={urlService.partnerOverview()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AssignDemandToPartnerTable} path={urlService.partnersAssignDemand()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AssignSupplyToPartnerTable} path={urlService.partnersAssignSupply()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AliasSupplyPartners} path={urlService.partnersAliasSupply()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AliasDemandPartners} path={urlService.partnersAliasDemand()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AddEditAlias} path={urlService.createAlias()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AddEditAlias} path={urlService.editAlias()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={PartnersSupplyTable} path={urlService.partnersSupply()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={OverviewSupplyTable} path={urlService.partnersOverviewSupply()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={PartnersDemandTable} path={urlService.partnersDemand()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={OverviewDemandTable} path={urlService.partnersOverviewDemand()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AddEditPartner} path={urlService.createPartner()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AddEditPartner} path={urlService.editPartner()}/>


                {/************** PUBLISHER DATA POINTS *************/}
                <ReduxProtectedRoute exact={false} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={PublisherDataPoints} path={urlService.publisherDataPoints()}/>

                {/************** PUBLISHER TAGS *************/}
                <ReduxProtectedRoute exact={false} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={PublisherTagsModule} path={urlService.publisherTags()}/>

                {/************** AD SERVER TAGS *************/}
                <ReduxProtectedRoute exact={false} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AdServerTagsModule} path={urlService.adServerTags()}/>

                {/************** ALERTS *************/}
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AlertsModule} path={urlService.alerts()}/>

                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AddAlert} path={urlService.createAlert()}/>

                <ReduxProtectedRoute exact={false} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={EditAlert} path={urlService.editAlert()}/>

                {/************** GROUPS *************/}
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={GroupsModule} path={urlService.groups()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AddGroup} path={urlService.createGroup()}/>

                <ReduxProtectedRoute exact={false} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={EditGroup} path={urlService.editGroup()}/>

                {/************** PRICE RULES *************/}
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={PriceRulesDashboard} path={urlService.priceRules()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AddEditPriceRule} path={urlService.createPriceRule()}/>
                <ReduxProtectedRoute exact={true} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={AddEditPriceRule} path={urlService.editPriceRule()}/>

                {/************** REPORTS *************/}
                <ReduxProtectedRoute exact={false} backendServiceName={BACKEND_SERVICE_NAME}
                                     requiredRoles={requiredAuthRoles}
                                     component={ReportsModule} path={urlService.reports()}/>

                <Route component={Login}/>
            </Switch>
        </section>
    )
};

export default Routes;
